import React from "react";
import { Link } from "react-router-dom";

const ActionCreate = ({ to, name }) => (
    <Link to={to} className="btn btn-primary btn-raised">
        Add New {name}
    </Link>
);
export default ActionCreate;
